import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';
import './PDQCodeHtml'

@customElement('pdq-tutorial-liquid-slicer')
class PDQTutorialLiquidSlicer extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
  ];

  render() {
    const code = `
<pdq-data-request id="posts-data" url="https://jsonplaceholder.typicode.com/posts" strategy="useStale"></pdq-data-request>
<pdq-data-request id="users-data" url="https://jsonplaceholder.typicode.com/users" strategy="useStale"></pdq-data-request>
<pdq-table id="users-table" source="users-data" index="id"></pdq-table>
<pdq-liquid>
<script type="application/json" slot="variables">
[
  {"name": "users", "source": "users-data"}
]
</script>
<script type="text/liquid" slot="liquid">
<cds-select id="users" helper-text="Select a user to filter posts by" label-text="User" placeholder="all users">
  <cds-select-item-group label="Users">
  {% for user in users %}  
    <cds-select-item value="{{user.id}}">{{user.username}} | {{user.name}} </cds-select-item>
  {% endfor %}
  </cds-select-item-group>
</cds-select>
</script>
<script slot="script" type="module">
export async function rendered(liquid) {
  this.shadowRoot.querySelector('#users')?.addEventListener('cds-select-selected', async (evt) => {
    const viewer = pdq.tableBroker.getViewer('posts')
    if(viewer)
      viewer.config = {...(viewer.config || {}), filter: [["userId", "==", evt.detail.value]]}
  }, {signal: this.signal}) // adding signal to the event listener, prevents duplicate event listeners
}
</script>
</pdq-liquid>
<pdq-table id="posts-table" source="posts-data"></pdq-table>
<pdq-perspective-viewer id="posts" table="posts-table" selectable></pdq-perspective-viewer>
`;
    return html`
      <cds-tile>
        <h2>Example: Building a slicer that uses the global data model</h2>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
      </cds-tile>
    `;
  }
}

(window as any).document.addEventListener('selected', (evt: CustomEvent) => {
  console.log('global event listener: selected', evt.detail);
})